import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/Button'
import { useConsultation } from '@/hooks/useConsultation'
import { useConsultationType } from '@/hooks/useConsultationType'
import { useTagManager } from '@/hooks/useTagManager'

export const WaitingForConsultationPayment = () => {
  const { t } = useTranslation()
  const { consultation } = useConsultation()
  const { consultationType } = useConsultationType()
  const { sendGTMEvent } = useTagManager()
  const [isRedirecting, setIsRedirecting] = useState(false)

  const redirectToCheckout = useCallback(() => {
    if (isRedirecting) return

    setIsRedirecting(true)
    sendGTMEvent(`${consultationType}_proceed_to_payment`)

    window.open(consultation?.paymentInformation?.url, '_blank', 'noopener,noreferrer')
  }, [consultation?.paymentInformation?.url, consultationType])

  return (
    <div className="flex flex-1 flex-col items-center gap-6 p-4">
      <p>{t('payment.description')}</p>

      <Button id="button-consultation-payment" onClick={redirectToCheckout} customClassName="uppercase" disabled={isRedirecting}>
        {t('payment.button')}
      </Button>
    </div>
  )
}
